const facilityCounterDisplay = document.getElementById("filtered-count");

document.addEventListener('DOMContentLoaded', () => {
    const facilityElements = document.querySelectorAll(".facility-item");
    facilityCounterDisplay.innerHTML = facilityElements?.length;
})

if (document.getElementsByClassName('market-table')[0]) {
    // after location search
    document.addEventListener('seGeoSearch', (event) => {
        facilityCounterDisplay.innerHTML = event.detail.count;
    })

    // after location feature filter
    document.addEventListener('seMarketFilter', (event) => {
        facilityCounterDisplay.innerHTML = event.detail.count;
    })
}